import React from 'react';
import { number } from 'prop-types';
import { facility } from 'config/constants';
import switchMapInfoSet from 'utils/switchMapInfo';
import iconAtm from 'assets/images/icon_facility_atm.svg';
import iconRest from 'assets/images/icon_facility_rest.svg'
import iconMilk from 'assets/images/icon_facility_milk.svg';
import iconTaxi from 'assets/images/icon_facility_taxi.svg';
import iconInfo from 'assets/images/icon_facility_infor.svg';
import iconCigar from 'assets/images/icon_facility_cigar.svg';
import iconToilet from 'assets/images/icon_facility_toilet.svg'
import iconLocker from 'assets/images/icon_facility_locker.svg';
import iconCharger from 'assets/images/icon_facility_charger.svg';
import iconElevator from 'assets/images/icon_facility_elevator.svg';
import iconEscalator from 'assets/images/icon_facility_escalator.svg';

import Facility from './Individual';

Facilities.propTypes = {
  rotate: number,
  floorIndex: number
};

function Facilities(props) {
  const { floorIndex, rotate } = props;
  const [state, setState] = React.useState({
    vertices: [],
    connections: [],
    deviceLocations: [],
    [facility.atms]: [],
    [facility.lockers]: [],
    [facility.toilets]: [],
    [facility.restArea]: [],
    [facility.babyCare]: [],
    [facility.smokeArea]: [],
    [facility.infoStall]: [],
    [facility.elevators]: [],
    [facility.escalators]: [],
    [facility.chargeArea]: [],
  });

  React.useEffect(() => {
    const staticDB = switchMapInfoSet(floorIndex);
    setState(staticDB);
  }, [floorIndex]);

  const mutualProps = {
    rotate,
    vertices: state.vertices,
    floorLevel: floorIndex
  }

  
  return (
    <>
      {/* Elevators */}
      <Facility
        href={iconElevator}
        arrayEle={state[facility.elevators]}
        {...mutualProps}
      />
      {/* Escaltors */}
      <Facility
        href={iconEscalator}
        arrayEle={state[facility.escalators]}
        {...mutualProps}
      />
      {/* Atms */}
      <Facility
        href={iconAtm}
        arrayEle={state[facility.atms]}
        {...mutualProps}
      />
      {/* Charger Area */}
      <Facility
        href={iconCharger}
        arrayEle={state[facility.chargeArea]}
        {...mutualProps}
      />
      {/* Rest Area */}
      <Facility
        href={iconRest}
        arrayEle={state[facility.restArea]}
        {...mutualProps}
      />
      {/* Smoke Area */}
      <Facility
        href={iconCigar}
        arrayEle={state[facility.smokeArea]}
        {...mutualProps}
      />
      {/* Toilet Area */}
      <Facility
        href={iconToilet}
        arrayEle={state[facility.toilets]}
        {...mutualProps}
      />
      {/* Lockers */}
      <Facility
        href={iconLocker}
        arrayEle={state[facility.lockers]}
        {...mutualProps}
      />
      {/* Infomation stall */}
      <Facility
        href={iconInfo}
        arrayEle={state[facility.infoStall]}
        {...mutualProps}
      />
      {/** Baby Care */}
      <Facility
        href={iconMilk}
        arrayEle={state[facility.babyCare]}
        {...mutualProps}
      />
      {/** Baby Care */}
      <Facility
        href={iconTaxi}
        arrayEle={state[facility.taxi]}
        {...mutualProps}
      />
    </>
  );
}

export default Facilities;